export const DOCS_CONFLUENCE_GUIDE = 'https://www.atlassian.com/software/confluence/guides';
